import { createRouter, createWebHistory } from 'vue-router';
const PicViewer = () => import('@/views/page/PicViewer.vue')

import { HomePage } from './modules/HomePage';

const ROUTER_BASE = import.meta.env.VITE_ROUTER_BASE
const router = createRouter({
  history: createWebHistory(),
  // base: '/tcins/',
  routes: [
    ...HomePage,
    {
      name: 'PCPicViewer',
      path: ROUTER_BASE + 'picViewer',
      component: PicViewer
    },
  ],
})

export default router